// issueSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { IssueFormFields, TIssueStatus } from "../../../../pages/ProjectScheduleManagement/issues/IssueInformationById";

interface IssueInDetailModal {
  id: number | string | null;
  open: boolean;
  projectId: number | string;
  projectName: string;
  activeTab: string;
  onClose?: "openProjectModal" | "openTaskModal";
  isFromWorkUI: boolean,
  selectedIssueDetails: any;
  formData: IssueFormFields;
  extra?: {
    issueName?: string | null;
    tags?: string[];
    assignee?: string | null;
    assigneeBy?: string | null;
    dueDate?: string | null;
    severity?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    status?: string | null;
    allowEdit?: boolean;
  };
  phaseResponse: {
    id: null;
    name: string;
    status: string;
    startDate: string;
    endDate: string;
  };
  projectResponse: {
    id: null;
    status: string;
    name: string;
  };
  taskResponse: {
    id: null;
    status: string;
    name: string;
  };
  allowEdit: boolean;
  approvalData?: {
    approvalLinkId: string;
    approvalStage: "Checker" | "Approver" | "Verifier";
    stateApprovals?: any[];
  } | null;
}

const initialFormData: IssueFormFields = {
  projectId: 0,
  issueId: 0,
  issueName: "",
  issueType: "",
  issueStatus: "Open",
  issueDescription: "",
  assignedTo: null,
  issueStartDate: undefined,
  deadlineDate: undefined,
  priorityId: null,
  linkedTask: null,
  releasePhaseId: null,
  issueTags: [],
  issueLinks: [],
  reminderFlag: false,
  severity: null,
  description: ""
};

const initialState: { data: IssueInDetailModal } = {
  data: {
    id: null,
    open: false,
    projectId: "",
    projectName: "",
    selectedIssueDetails: null,
    formData: initialFormData,
    activeTab: "activities",
    onClose: "openProjectModal",
    extra: {
      issueName: "",
      tags: [],
      assignee: "",
      assigneeBy: "",
      dueDate: "",
      severity: "",
      createdAt: "",
      updatedAt: "",
      status: "",
      allowEdit: false,
    },
    phaseResponse: {
      id: null,
      name: "",
      status: "",
      startDate: "",
      endDate: "",
    },
    projectResponse: {
      id: null,
      status: "",
      name: "",
    },
    taskResponse: {
      id: null,
      status: "",
      name: "",
    },
    allowEdit: true,
    approvalData: null,
    isFromWorkUI: false,
  },
};

export const IssueInDetailModalSlice = createSlice({
  name: "IssueInDetailModalSlice",
  initialState,
  reducers: {
    updateIssueInDetailModalSlice(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    updateFormData(state, action) {
      state.data.formData = { ...state.data.formData, ...action.payload };
    },
    resetIssueInDetailModalSlice(state) {
      state.data = initialState.data;
    },
    setInitialFormData(state, action) {
      state.data.formData = {
        ...initialFormData,
        ...action.payload,
      };
    },
    setIssueApprovalData(state, action: PayloadAction<IssueInDetailModal["approvalData"]>) {
      state.data.approvalData = action.payload;
    },
  },
});

export const {
  updateIssueInDetailModalSlice,
  resetIssueInDetailModalSlice,
  updateFormData,
  setInitialFormData,
  setIssueApprovalData
} = IssueInDetailModalSlice.actions;

export default IssueInDetailModalSlice.reducer;

export const RootPageRenderSlice = createSlice({
  name: "RootPageRenderSlice",
  initialState: initialState,
  reducers: {
    updateRootPageRenderState: (state, action) => {
      // call when entering to root page
      state.data = action.payload;
    },
  },
});

export const { updateRootPageRenderState } = RootPageRenderSlice.actions;
